angular.module('autoremind.communications')
    .directive('communicationsTargetShortnotice', ['jobService', 'dialogs', function (jobService, dialogs) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/communication/forms/communications-target-shortnotice.html',
            link: function ($scope, element, attrs) {
                // TODO: move to jobService?
                /**
                 * Add a target to a list of targets for the job (so far only shortnotice uses this)
                 */
                $scope.addToTargetGroup = function () {
                    if (jobService.job.targetDate === null || jobService.job.targetDate === '') {
                        dialogs.notify('Note', 'You must select the appointment date');
                        return;
                    }
                    jobService.job.setEdited(true);
                    var date = jobService.job.targetDate;
                    var dateNoTime = date.getFullYear() + "-" +
                        ('0' + (date.getMonth() + 1)).slice(-2) + "-" +
                        ('0' + date.getDate()).slice(-2);
                    var target = {
                        "type": "appointmentDate",
                        "acceptAppointmentStates": ["scheduled", "confirmed", "completed", "missed"],
                        //"date": angular.copy($scope.viewModel.targetDate),
                        "date": dateNoTime,
                    };
                    //var providerId = angular.copy(jobService.selectedProvider.providerId);
                    var providerId = angular.copy(jobService.selectedProviderId);
                    if (providerId !== undefined && providerId !== null) {
                        target.providerId = providerId;
                    }
                    //$scope.viewModel.targetGroup.push(target);
                    if ($scope.job.targets === undefined)
                        $scope.job.targets = [];
                    $scope.job.targets.push(target);
                    $scope.job.updateTargetStats(); // TODO: Consider using a watch inside service that will do this?
                    //$scope.updateChart();
                };
            }
        };
    }]);
//# sourceMappingURL=communications-target-shortnotice.js.map